export const SET_RESEAUX = 'SET_RESEAUX';
export const SET_RESEAUX_HORS_SECTEUR = 'SET_RESEAUX_HORS_SECTEUR';
export const SET_SHOW_RESEAUX = 'SET_SHOW_RESEAUX';
export const SET_MARKER_RESEAUX = 'SET_MARKER_RESEAUX';
export const SET_MARKER_FACES_DE_RESEAUX = 'SET_MARKER_FACES_DE_RESEAUX';
export const TRIE_RESEAUX = 'TRIE_RESEAUX';



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/reseauxTempo-mutation-type.js